import ReCAPTCHAv3 from '../common/ReCAPTCHAv3';
import loadScript from '../common/loadScript';

let App = window.App;
App.writeUs = {};

App.writeUs.submitForm = function ($btn) {
    ReCAPTCHAv3.request('submit', App.modal.submitForm, function (message) {
        let $form = $btn.closest('.modal').find('form');
        $form.find('.alert.alert-error').remove();
        App.modal.showErrors($form, message);
    });
}

$('[data-modal="#writeUsModal"]').on('click', function () {
    loadScript('https://www.google.com/recaptcha/api.js?render=' + $('input[name="captcha_token"]').val());
});